module.exports = {
  GOOGLE_MAPS_API_KEY: "AIzaSyByoHs7jFtmD7GsZeFLpEbWg6pun0yWpos",
  LIBRARIES: ["places"],
};
